<template>
  <div id="app">

    <div class="container">
      <br>
    </div>
    <div class="container bg-white">
      <div class="columns">
        <div class="column">
          <Profile v-bind:user="firstEnemy"/>
          <br />
          <Profile v-bind:user="secondEnemy"/>
        </div>
        <div class="column is-three-fifths">
          <div class="tabs is-centered">
            <ul>
                <li>
                  <p class="title is-4">
                    Тестовый бой
                  </p>
                </li>
            </ul>
          </div>
          <b-switch
            true-value="ok"
            false-value="stop"
            v-model="battleStatus"
            size="is-medium"
            type="is-success"
          >{{ battleStatus }}</b-switch>
          <button
            type="button"
            class="button is-primary is-small"
            v-on:click="isCardModalActive = true"
          >
            Настроить корабль
          </button>
          <b-modal v-model="isCardModalActive" full-width scroll="keep">
            <Ship
              v-bind:ship="currentUser.ship"
              v-bind:devices="devices"
            /> 
          </b-modal>
          <progress class="progress is-primary" v-bind:value="maxTimerCount - timerCount" v-bind:max="maxTimerCount"></progress>
          <div class="block battle-area">
            <div class="content is-small">
              <div class="box" v-for="step in steps">
                <p class="title is-6">Ход {{ step.step }}</p>
                <p v-for="msg in step.message">{{ msg }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <Profile v-bind:user="currentUser"/>
          <br />
          <Profile v-bind:user="friendHero"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Profile from './components/TestBattleProfile'
import Ship from './components/TestBattleShip'
import ShipService from './services/TestBattleShipService'

export default {
  components: {
    Profile,
    Ship,
  },
  data: function () {
    return {
      isCardModalActive: false,
      devices: [
        { kind:'weapon', name: 'Детский лазер', type: 'laser', damage: 10, power_consumption: 25, strength: 10, current_strength: 10, enabled: false },
        { kind:'weapon', name: 'Лазерная указка', type: 'laser', damage: 14, power_consumption: 30, strength: 10, current_strength: 10, enabled: false },
        { kind:'weapon', name: 'Петарда', type: 'rocket', damage: 15, accuracy: 1.3, power_consumption: 15, strength: 10, current_strength: 10, stock: 10, enabled: false },
        { kind:'weapon', name: 'Фейерверк', type: 'rocket', damage: 20, accuracy: 1.3, power_consumption: 20, strength: 10, current_strength: 10, stock: 10, enabled: false },
        { kind:'protector', name: 'Зонтик от солнца', type: 'energetic_field', weapon: 'laser', absorption: 0.85, power_consumption: 15, strength: 15, current_strength: 15, enabled: false },
        { kind:'protector', name: 'Солнцезащитные очки', type: 'energetic_field', weapon: 'laser', absorption: 0.9, power_consumption: 20, strength: 15, current_strength: 15, enabled: false },
        { kind:'protector', name: 'Сачок для насекомых', type: 'missile_traps', weapon: 'rocket', absorption: 0.5, per_shot: 9, stock: 90, power_consumption: 10, strength: 15, current_strength: 15, enabled: false },
        { kind:'protector', name: 'Мухобойка', type: 'missile_traps', weapon: 'rocket', absorption: 0.65, per_shot: 9, stock: 90, power_consumption: 15, strength: 15, current_strength: 15, enabled: false },
        { kind:'energy', name: 'Энерджайзер', type: 'atom', power_generation: 50, strength: 15, current_strength: 15, enabled: true },
        { kind:'energy', name: 'Дюраселл', type: 'atom', power_generation: 70, strength: 15, current_strength: 15, enabled: true },
      ],
      currentUser: {
        status: 'available',
        team: 'heroes',
        spaceship_image: '/img/imperial_trader.jpg',
        avatar: '/img/avatar_1.png',
        name: 'Hero',
        username: 'hero',
        ship: {
          max_power: 50,
          strength: 100,
          current_strength: 100,
          devices: [
            {},{},{},{},{}
          ],
          //   { id: 1, kind:'weapon', name: 'Детский лазер', type: 'laser', damage: 10, power_consumption: 25, strength: 10, current_strength: 10, enabled: false },
          //   { id: 2, kind:'weapon', name: 'Петарда', type: 'rocket', damage: 15, accuracy: 1.3, power_consumption: 15, strength: 10, current_strength: 10, stock: 90, enabled: false },
          //   { id: 3, kind:'protector', name: 'Зонтик от солнца', type: 'energetic_field', weapon: 'laser', absorption: 0.85, power_consumption: 15, strength: 15, current_strength: 15, enabled: false },
          //   { id: 4, kind:'protector', name: 'Сачок для насекомых', type: 'missile_traps', weapon: 'rocket', absorption: 0.9, stock: 50, power_consumption: 10, strength: 15, current_strength: 15, enabled: false },
          // ]
        },
      },
      friendHero: {
        status: 'available',
        team: 'heroes',
        spaceship_image: '/img/ship_1.png',
        avatar: '/img/avatar_1.png',
        name: "Hero's friend",
        username: 'friend',
        ship: {
          max_power: 50,
          strength: 100,
          current_strength: 100,
          devices: [
            { kind:'weapon', name: 'Детский лазер', type: 'laser', damage: 10, power_consumption: 25, strength: 10, current_strength: 10, enabled: true },
            { kind:'protector', name: 'Сачок для насекомых', type: 'missile_traps', weapon: 'rocket', absorption: 0.75, stock: 10, power_consumption: 10, strength: 15, current_strength: 15, enabled: true },
            { kind:'energy', name: 'Дюраселл', type: 'atom', power_generation: 70, strength: 15, current_strength: 15, enabled: true },
          ]
        },
      },
      firstEnemy: {
        status: 'available',
        team: 'enemy',
        spaceship_image: '/img/ship_1.png',
        avatar: '/img/avatar_1.png',
        name: 'firstEnemy',
        username: 'firstEnemy',
        ship: {
          max_power: 40,
          strength: 70,
          current_strength: 70,
          devices: [
            { kind:'weapon', name: 'Неизвестный лазер', type: 'laser', damage: 15, power_consumption: 15, strength: 10, current_strength: 10, enabled: true },
            { kind:'protector', name: 'Неизвестный зонт', type: 'energetic_field', weapon: 'laser', absorption: 0.75, power_consumption: 15, strength: 15, current_strength: 15, enabled: true },
            { kind:'energy', name: 'Дюраселл', type: 'atom', power_generation: 70, strength: 15, current_strength: 15, enabled: true },
          ],
        },
      },
      secondEnemy: {
        status: 'available',
        team: 'enemy',
        spaceship_image: '/img/ship_1.png',
        avatar: '/img/avatar_1.png',
        name: 'secondEnemy',
        username: 'secondEnemy',
        ship: {
          max_power: 40,
          strength: 70,
          current_strength: 70,
          devices: [
            { kind:'weapon', name: 'Неизвестная ракета', type: 'rocket', damage: 15, accuracy: 1.5, power_consumption: 15, strength: 10, current_strength: 10, stock: 90, enabled: true },
            { kind:'protector', name: 'Неизвестная мухобойка', type: 'missile_traps', weapon: 'rocket', absorption: 0.75, stock: 50, power_consumption: 10, strength: 15, current_strength: 15, enabled: true },
            { kind:'energy', name: 'Дюраселл', type: 'atom', power_generation: 70, strength: 15, current_strength: 15, enabled: true },
          ],
        },
      },
      currentStep: 1,
      maxTimerCount: 5,
      timerCount: 1,
      steps: [],
      battleStatus: 'stop',
      currentMessages: ["Бой начался!"]
    }
  },
  created() {
  },
  methods: {
    enemyShoots() {
      // перебираем всех врагов
      let enemies = [this.firstEnemy, this.secondEnemy].filter(
        target => target.status === 'available'
      )
      enemies.forEach(shooter => {
        let heroes = [this.friendHero, this.currentUser].filter(el => el.status == 'available')
        if (heroes.length > 0) {
          let hero = heroes[Math.floor(Math.random() * heroes.length)]
          this.shooting(shooter, hero)
        } else {
          this.battleStatus = 'stop'
        }
      })
    },
    heroesShoots() {
      // перебираем всех героев
      let enemies = [this.firstEnemy, this.secondEnemy].filter(el => el.status == 'available')
      if (enemies.length > 0) {
        let enemy = enemies[Math.floor(Math.random() * enemies.length)]
        this.shooting(this.currentUser, enemy)
        enemy = enemies[Math.floor(Math.random() * enemies.length)]
        if (this.friendHero.status === 'available') this.shooting(this.friendHero, enemy)
      } else {
        this.battleStatus = 'stop'
      }
    },
    shooting(shooter, target) {
      // ищем включенное оружие
      ShipService.weapons(shooter.ship).filter(
        weapon => weapon.enabled === true
      ).forEach(weapon => {
        let protector_absorption = 0.0
        let protectors = ShipService.protections(target.ship).filter(item => item.enabled == true)

        switch(weapon.type) {
          case 'rocket':
            if (weapon.stock === 0) break

            let rocketProtectors = protectors.filter(protector => protector.weapon == weapon.type && protector.stock > 0)
            rocketProtectors.forEach(protector => protector_absorption += (protector.absorption || 0.0))

            let chance = weapon.accuracy - protector_absorption

            if (chance > 0.0 && chance > Math.random()) {
              this.currentMessages.push(`${shooter.name} стрелял в ${target.name} попал из ${weapon.name}, нанеся ${weapon.damage} единиц урона`)
              target.ship.current_strength -= weapon.damage > target.ship.current_strength ? target.ship.current_strength :  weapon.damage
            } else {
              this.currentMessages.push(`${shooter.name} стрелял в ${target.name} из ${weapon.name} и не пробил.`)
            }

            rocketProtectors.forEach(protector => protector.stock -= protector.per_shot )
            weapon.stock -= 1
            break
          case 'laser':
            protectors.filter(protector => protector.weapon == weapon.type)
            protectors.forEach(protector => protector_absorption += (protector.absorption || 0.0))

            let damage = protector_absorption * weapon.damage

            if (weapon.damage > damage) {
              let finDamage = Math.floor(weapon.damage - damage)
              this.currentMessages.push(`${shooter.name} стрелял в ${target.name} и попал из ${weapon.name}, нанеся ${finDamage} единиц урона`)
              target.ship.current_strength -= finDamage > target.ship.current_strength ? target.ship.current_strength : finDamage
            } else {
              this.currentMessages.push(`${shooter.name} стрелял в ${target.name} из ${weapon.name} и не пробил.`)
            }
            break
        }
      })
    },
    makeWar() {
      this.enemyShoots()
      this.heroesShoots()
    },
    cardModal() {
      this.$buefy.modal.open({
        parent: this,
        component: Ship,
        hasModalCard: true,
        trapFocus: true
      })
    }
  },
  watch: {
    battleStatus: {
      handler(value) {
        this.timerCount = this.maxTimerCount
      }
    },
    timerCount: {
      handler(value) {
        if (this.battleStatus === 'ok') {
          if (value > 0) {
            setTimeout(() => {
              this.timerCount -= 0.1;
            }, 100);
          } else {
            if (this.currentStep > 1)
              this.makeWar();

            [this.firstEnemy, this.secondEnemy, this.currentUser, this.friendHero].filter(
              member => member.ship.current_strength <= 0 && member.status == 'available'
            ).forEach(member => {
              member.status = 'unavailable'
              this.currentMessages.push(`${member.name} выбыл`)
            })

            this.steps.unshift({ step: this.currentStep, message: this.currentMessages })

            if (this.currentUser.ship.current_strength <= 0) this.battleStatus = 'stop'
            this.currentMessages = []
            this.timerCount = this.maxTimerCount
            this.currentStep += 1
          }
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  }
}
</script>

<style scoped>
  .battle-area {
    overflow-y: auto;
    max-height: 80vh;
    padding: 5px;
  }

  .bg-white {
    background-color: white;
    padding: 15px;
  }
</style>